// @flow
import TariffsList from './TariffsList';

export default TariffsList;
